import * as Sentry from '@sentry/vue'

export const sendExceptionToAnalytics = (message: any) => {
  if (import.meta.env.MODE !== 'production') return
  Sentry.captureException(new Error(message))
}
